// Partial overlay: only QA-provided overrides; everything else falls back to Intl.DisplayNames.
export default [
  {alpha: 'CD', name: 'Demokratische Republik Kongo'},
  {alpha: 'CG', name: 'Republik Kongo'},
]
